import Vue from 'vue';
import Component from 'vue-class-component';
import { TOOLS_ROUTES } from '@/tools/tools.router';
import EdMyInfoAdminComponent from '@/tools/components/ed-my-info-admin/ed-my-info-admin.component.vue'
import EdResetPasswordComponent from '@/auth/components/ed-reset-password/ed-reset-password.component.vue'
import EdMyCalendarComponent from '@/tools/components/ed-my-calendar/ed-my-calendar.component.vue';

@Component({
    name: 'my-info',
    components: {
        EdMyInfoAdmin: EdMyInfoAdminComponent,
        EdResetPassword: EdResetPasswordComponent,
        EdMyCalendar: EdMyCalendarComponent
    }
  })

export default class MyInfoView extends Vue {
  goToRecentActivity() {
    this.$router.push({
      name: TOOLS_ROUTES.RECENT_ACTIVITY.NAME
    });
  }
}
